import { render, staticRenderFns } from "./Report-detail.vue?vue&type=template&id=7b40bde6"
import script from "./Report-detail.vue?vue&type=script&lang=js"
export * from "./Report-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports